module.exports = __webpack_public_path__ + "fonts/nunito-sans-v6-latin-800.a28845a6.woff";